import { render, staticRenderFns } from "./Draggable.vue?vue&type=template&id=13ea8a2b&"
import script from "./Draggable.vue?vue&type=script&lang=js&"
export * from "./Draggable.vue?vue&type=script&lang=js&"
import style0 from "./Draggable.vue?vue&type=style&index=0&id=13ea8a2b&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports